import { DOCUMENT, Inject, Injectable } from '@angular/core';
import { environment } from '@environment';
import { WINDOW } from '@ess-front/shared';

interface DataLayerObject {
  [key: string]: unknown;
  event: string;
}

export interface WindowWithDataLayer extends Window {
  dataLayer?: DataLayerObject[];
}

@Injectable({
  providedIn: 'root',
})
export class GoogleTagManagerService {
  private readonly GOOGLE_TAG_MANAGER_URL = 'https://www.googletagmanager.com/gtm.js';
  private isInitialized = false;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(WINDOW) private window: WindowWithDataLayer,
  ) {}

  init(): void {
    if (!this.isInitialized) {
      this.isInitialized = true;
      this.initializeDataLayer();
      this.injectGtmScript();
      this.pushEvent('gtm.js', { 'gtm.start': new Date().getTime() });
    }
  }

  pushEvent(eventName: string, eventData?: Record<string, unknown>): void {
    this.window.dataLayer?.push({
      event: eventName,
      ...eventData,
    });
  }

  private injectGtmScript(): void {
    const script = this.document.createElement('script');
    script.async = true;
    script.src = `${this.GOOGLE_TAG_MANAGER_URL}?id=${environment.gtmApiKey}`;
    this.document.head.appendChild(script);
  }

  private initializeDataLayer(): void {
    this.window.dataLayer = [];
  }
}
